import * as t from 'io-ts';

export const warehouseHolidayBase = t.type({
  warehouse: t.number,
  date: t.string,
});

export type WarehouseHolidayBase = t.TypeOf<typeof warehouseHolidayBase>;

export const warehouseHoliday = t.type({
  ...warehouseHolidayBase.props,
  id: t.number,
  updated_at: t.string,
  created_at: t.string,
});

export type WarehouseHoliday = t.TypeOf<typeof warehouseHoliday>;

export const warehouseHolidayQueryParams = t.partial({
  warehouse_id: t.number,
  agency_id: t.number,
  date_after: t.string,
  date_before: t.string,
});

export type WarehouseHolidayQueryParams = t.TypeOf<typeof warehouseHolidayQueryParams>;
